import en from "./en";
import jp from "./ja";

// jsonを結合する
var data = Object.assign(en, jp);

export { data };
